import { Alert, Card, CardContent, CardHeader } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { Commons } from "../../helper/CommonService";
import { StickyNote2 } from "@mui/icons-material";
import PDFPengumuman from "../PDF/PDFPengumuman";
import DownloadPDFButtons from "../general/DownloadPDFButtons";
import { CONFIG_PENDAFTARAN, STATUS_PROGRESS } from "../../helper/Constant";
import PDFCommon from "../PDF/PDFCommon";

function DetailPengumuman({ data_santri }) {
    const [pengumumanDate, setPengumumanDate] = useState();
    const hasilPengumumanRef = useRef();
    useEffect(() => {
        Commons.GetAdditionalInformation(CONFIG_PENDAFTARAN.TGL_PENGUMUMAN_TEST)
            .then((respPengumumanDate) => {
                setPengumumanDate(respPengumumanDate);
            });
    }, []);
    const GenerateContent = () => {
        if (data_santri.status === STATUS_PROGRESS.PENGUMUMAN) {
            const buttonsConfig = [
                {
                    label: 'Hasil Pengumuman',
                    icon: StickyNote2,
                    ref: hasilPengumumanRef,
                    pdfComponent: PDFCommon,
                    fileName: `hasil-pengumuman-${data_santri.no_daftar}.pdf`,
                    data: { dataSantri: data_santri, templateKey: 'pengumuman' },
                }
            ];

            return (
                <>
                    Download berkas berikut untuk melihat hasil Test/Ujian.
                    <DownloadPDFButtons buttons={buttonsConfig}></DownloadPDFButtons>
                </>
            )
        }

        return (
            <Alert title="Pengumuman belum bisa dilihat" variant="filled" severity="warning" sx={{ marginBottom: "15px" }}>
                Pengumuman insya Allah muncul pada bagian ini tanggal {pengumumanDate}.
            </Alert>
        )

    }
    return (
        <>
            <Card>
                <CardHeader title="Pengumuman Penerimaan" sx={{ borderBottom: "1px solid #f4f4f4" }}>
                </CardHeader>
                <CardContent>
                    {GenerateContent()}
                </CardContent>
            </Card>
        </>
    )
}

export default DetailPengumuman;